// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: '__apiUrl__',
  appNameDisplayLength:'__appNameDisplayLength__',
  hideApps:'__hideApps__',
  alleAuthConfig: {
    clientID: '__clientID__',
    domain: '__domain__',
    responseType: 'token id_token',
    audience: '__audience__',
    redirectUri: '__redirectUri__',
    logoutUrl: '__logoutUrl__',
    inAppRedirects: {
      loggedIn: '/callback',
      error: '/error'
    }
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */